// extracted by mini-css-extract-plugin
module.exports = {"container":"container___EmYHl","icon":"icon___YFLCe","text":"text___3JewD"};